import get from 'lodash/get'

// These shouldn't be changing since neither the tooltip nor the viz is resized with the window.
const TIP_HEIGHT_DEFAULT = 202
const TIP_OVERFLOW_OFFSET = 20
const TIP_FOUL_OFFSET = 34
const TIP_IN_PLAY_OFFSET = 63
const VIZ_RIGHT_EDGE = 670

export default function Tooltip(event, settings, tipData = null) {
    const tip = settings.toolTip.current

    if (tipData) {
        let x
        let y
        const eventData = get(event, 'currentTarget.cx')

        if (eventData) {
            x = event.currentTarget.cx.baseVal.value + 5
            y = event.currentTarget.cy.baseVal.value
        } else {
            x = event.currentTarget.transform.baseVal[0].matrix.e + 5
            y = event.currentTarget.transform.baseVal[0].matrix.f
        }

        let tipHeight = TIP_HEIGHT_DEFAULT
        const tipWidth = settings.vizWidth / 2

        if (tipData.includes('Foul') && tipData.includes('Exit Velocity')) {
            // Vertical tooltip offset for foul balls (with EV/LA lines)
            tipHeight += TIP_FOUL_OFFSET
        } else if (tipData.includes('(Blocked)')) {
            // Offset for Swinging Strike (Blocked) wrapping to new line
            tipHeight += TIP_OVERFLOW_OFFSET
        } else if (tipData.includes('Contact Type:')) {
            // Offset for in-play balls introducing exit velo, contact type lines
            tipHeight += TIP_IN_PLAY_OFFSET
            if (!tipData.includes('Exit Velocity')) {
                // Offset for in-play balls that do not have EV/LA data
                tipHeight -= TIP_FOUL_OFFSET
            }
            if (tipData.includes('Double Play')) {
                tipHeight += TIP_OVERFLOW_OFFSET
            }
        }

        if (y + tipHeight > settings.vizHeight) y -= tipHeight
        if (x + tipWidth > VIZ_RIGHT_EDGE) x -= tipWidth + 5

        tip.innerHTML = `
        <foreignObject x=${x} y=${y} width=${settings.vizWidth / 2} height=${
            settings.vizHeight
        }>
                <div class="evp-svg-tooltip">
                ${tipData}
                </div>
        </foreignObject>
        `
    } else {
        tip.innerHTML = null
    }
}
